import TareasProgramadas from './tareasprogramadas.vue';
import TareasProgramadasForm from './tareasprogramadas-form.vue';
import RoutesUtils from '../../js/RoutesUtils.js';

var routes = [
    {
        path: '/tareasprogramadas/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('tareasprogramadas', ['ADMIN'], TareasProgramadas),
        keepAlive: true
    },
    {
        path: '/tareasprogramadas/new/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('tareasprogramadas/new', ['ADMIN'], TareasProgramadasForm)
    },
    {
        path: '/tareasprogramadas/edit/:id/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('tareasprogramadas/edit', ['ADMIN'], TareasProgramadasForm)
    },
    {
        path: '/tareasprogramadas/view/:id/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('tareasprogramadas/view', ['ADMIN'], TareasProgramadasForm, { editable: false })
    }
];

export default routes;
